var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5668 8.54557L19.0002 14.3789H5.00016L8.50016 9.82891L10.9502 12.9789L14.3335 8.54557H14.5668ZM7.91683 8.54557C8.85016 8.54557 9.66683 7.72891 9.66683 6.79557C9.66683 5.86224 8.85016 5.04557 7.91683 5.04557C6.9835 5.04557 6.16683 5.86224 6.16683 6.79557C6.16683 7.72891 6.9835 8.54557 7.91683 8.54557ZM23.6668 2.71224V16.7122C23.6668 17.9956 22.6168 19.0456 21.3335 19.0456H2.66683C1.3835 19.0456 0.333496 17.9956 0.333496 16.7122V2.71224C0.333496 1.42891 1.3835 0.378906 2.66683 0.378906H21.3335C22.6168 0.378906 23.6668 1.42891 23.6668 2.71224ZM21.3335 5.97891V2.71224H2.66683V16.7122H21.3335V5.97891Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.586012748e0a30b05499879c754e43a0.svg";
export { ForwardRef as ReactComponent };